/* eslint sort-keys: "error" */
export default {
  /* german */
  de: {
    'statistics_activity_from_to': 'Übersicht von {date1} - {date2}',
    'statistics_billable_hours': 'Abrechenbare Stunde diesen Monat | Abrechenbare Stunden diesen Monat',
    'statistics_customers': 'Kunden',
    'statistics_customers_month': 'Du hast in den letzten 30 Tagen <span class="dash-number-box__value--sub-highlighted">{value} Kunden</span> dazugewonnen',
    'statistics_expenses': 'Ausgaben',
    'statistics_expenses_month': 'Ausgaben in <span class="dash-number-box__value--sub-highlighted">diesem Monat</span>',
    'statistics_open_hours': 'Nicht abgerechnte Stunde | Nicht abgerechnete Stunden',
    'statistics_overdue_invoices': 'Überfällige Rechnungen | 1 überfällige Rechnung | {number} überfällige Rechnungen',
    'statistics_project_hours': 'Projektstunden',
    'statistics_project_hours_month': 'Übersicht des aktuellen Monats',
    'statistics_project_hours_no_data': 'Nicht genügend Daten für den aktuellen Monat',
    'statistics_revenue': 'Umsatz',
    'statistics_revenue_month': 'Umsatz in <span class="dash-number-box__value--sub-highlighted">diesem Monat</span>',
    'statistics_unpaid_invoices': 'Unbezahlte Rechnungen | 1 unbezahlte Rechnung | {number} unbezahlte Rechnungen'
  },

  /* english */
  en: {
    'statistics_activity_from_to': 'Activity from {date1} - {date2}',
    'statistics_billable_hours': 'Billable Hour This Month | Billable Hours This Month',
    'statistics_customers': 'Customers',
    'statistics_customers_month': 'You gained <span class="dash-number-box__value--sub-highlighted">{value} customers</span> in the last 30 days',
    'statistics_expenses': 'Expenses',
    'statistics_expenses_month': 'Expenses <span class="dash-number-box__value--sub-highlighted">this month</span>',
    'statistics_open_hours': 'Unbilled Hour | Unbilled Hours',
    'statistics_overdue_invoices': 'Overdue Invoices | 1 Overdue Invoice | {number} Overdue Invoices',
    'statistics_project_hours': 'Project Hours',
    'statistics_project_hours_month': 'Overview over this month',
    'statistics_project_hours_no_data': 'Not enough data for this month',
    'statistics_revenue': 'Revenue',
    'statistics_revenue_month': 'Revenue <span class="dash-number-box__value--sub-highlighted">this month</span>',
    'statistics_unpaid_invoices': 'Unpaid Invoices | 1 Unpaid Invoice | {number} Unpaid Invoices'
  }
}
